/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";

export default function ContentLayoutManageContents() {
  return (
    <div>
      <div>
        <h2 className="helpHeaderTitle">Manage Content </h2>
        <div className="helpContentSection">
          {" "}
          <div className="mb-3">
            <div className="boldTitle mt-2">Search Content </div>
            <div>
              In the content tab, you can search or sort content by Name (1),
              Tag (2), or by file type (3)
            </div>
          </div>
          <img
            alt=""
            src={require("../../assets/images/helpCenter/contentCenterImg3.png")}
          />{" "}
          <div className="mb-3">
            <div className="boldTitle mt-2">View & Edit Content </div>
            <div>
              Click on the content name OR the “View icon” adjacent to it to
              view, delete or edit content parameters (name, size, tags)
            </div>
          </div>{" "}
          <img
            alt=""
            src={require("../../assets/images/helpCenter/contentCenterImg4.png")}
          />{" "}
          <div className="mb-3">
            <div className="boldTitle mt-2">Replace/Update Content</div>
            <div>
              You can edit or replace content by selecting another file from
              your computer to replace that piece of content with - this will
              replace that content wherever it exists within a campaign or
              playlist.
            </div>
          </div>
          <img
            alt=""
            src={require("../../assets/images/helpCenter/contentCenterImg5.png")}
          />{" "}
        </div>
      </div>
    </div>
  );
}
